import { useState } from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const LikeComponent = ({ userDetails }) => {
  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(userDetails.LikeCount);
  const navigate = useNavigate();

  const handleLike = async () => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      try {
        const likerId = localStorage.getItem("userId");
        const userId = userDetails.UserId;
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}api/signup/like-user`,
          { LikerId: likerId, UserId: userId }
        );
        const { value, likesCount } = response.data.body;
        if (value === "User liked successfully") {
          setLiked(true);
          setLikesCount(likesCount);
          toast.success("Profile liked");
        } else if (value === "User unliked successfully") {
          setLiked(false);
          setLikesCount(likesCount);
        } else {
          toast.error(value);
        }
      } catch (error) {
        console.error("Error occurred while liking project:", error);
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <div>
      <button onClick={handleLike}>
        {liked ? (
          <FavoriteIcon style={{ color: "red" }} />
        ) : (
          <FavoriteBorderIcon />
        )}
        ({likesCount})
      </button>
    </div>
  );
};

export default LikeComponent;
